exports.defaultMetricMap = {
    impressions: {
        metric: 'impressions',
        title: 'Impressions',
        format: 'number',
        invert: false
    },
    total_activities: {
        metric: 'total_activities',
        title: 'Total Activities',
        format: 'number',
        invert: false
    },
    ecpa_activities: {
        metric: 'ecpa_activities',
        title: 'eCPA Activities',
        format: 'number',
        invert: false
    },
    ecpa: {
        metric: 'ecpa',
        title: 'eCPA',
        format: 'price',
        invert: true
    },
    completed_plays: {
        metric: 'completed_plays',
        title: 'Completions',
        format: 'number',
        invert: false
    },
    cpcv: {
        metric: 'cpcv',
        title: 'CPCV',
        format: 'price',
        invert: false
    },
    completion_rate: {
        metric: 'completion_rate',
        title: 'Completion Rate',
        format: 'percentage',
        invert: false
    },
    actions: {
        metric: 'actions',
        title: 'Actions',
        format: 'number',
        invert: false
    },
    conversions: {
        metric: 'conversions',
        title: 'Conversions',
        format: 'number',
        invert: false
    },
    cost_per_conversion: {
        metric: 'cost_per_conversion',
        title: 'Cost per Conversion',
        format: 'price',
        invert: false
    },
    clicks: {
        metric: 'clicks',
        title: 'Clicks',
        format: 'number',
        invert: false
    },
    link_clicks: {
        metric: 'link_clicks',
        title: 'Link Clicks',
        format: 'number',
        invert: false
    },
    ctr: {
        metric: 'ctr',
        title: 'CTR',
        format: 'percentage',
        invert: false
    },
    cpc: {
        metric: 'cpc',
        title: 'CPC',
        format: 'price',
        invert: true
    },
    conversion_rate: {
        metric: 'conversion_rate',
        title: 'Conversion Rate',
        format: 'percentage',
        invert: false
    }
};

exports.calloutMap = {
    ecpa: {
        display: ['impressions', 'ecpa_activities', 'ecpa'],
        mobile: ['impressions', 'ecpa_activities', 'ecpa'],
        native: ['impressions', 'ecpa_activities', 'ecpa'],
        video: ['completed_plays', 'completion_rate', 'cpcv'],
        tv: ['completed_plays', 'completion_rate', 'cpcv'],
        sem: ['clicks', 'ctr', 'conversion_rate'],
        audio: ['impressions', 'ecpa_activities', 'completion_rate'],
        social: ['impressions', 'conversions', 'clicks'],
        site: ['impressions', 'ecpa_activities'],
        youtube: ['completed_plays', 'completion_rate', 'cpcv'],
    },
    ctr: {
        display: ['impressions', 'clicks', 'ctr'],
        mobile: ['impressions', 'clicks', 'ctr'],
        native: ['impressions', 'clicks', 'ctr'],
        video: ['completed_plays', 'completion_rate', 'cpcv'],
        tv: ['completed_plays', 'completion_rate', 'cpcv'],
        sem: ['clicks', 'ctr', 'conversion_rate'],
        audio: ['impressions', 'clicks', 'ctr'],
        site: ['impressions', 'clicks', 'ctr'],
        social: ['impressions', 'actions', 'conversions'],
        youtube: ['completed_plays', 'completion_rate', 'cpcv'],
    }
};



// WEBPACK FOOTER //
// ./src/constants/callouts.js